import { render } from "./GrattersModal.vue?vue&type=template&id=d105cc6e&scoped=true"
import script from "./GrattersModal.vue?vue&type=script&lang=js"
export * from "./GrattersModal.vue?vue&type=script&lang=js"

import "./GrattersModal.vue?vue&type=style&index=0&id=d105cc6e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d105cc6e"]])

export default __exports__